import {
  CommonSharedByType,
  mapCommonSharedByType,
} from "../../Share/CommonSharedByType";
import { mapShareContactTypes, ShareContactTypes } from "../ShareContactTypes";
import {
  mapSpendingDataTypes,
  ProjectSpendingDataType,
} from "./ProjectSpendingDataType";

export interface ProjectSpendingTypes {
  project_id: number;
  job_number: string;
  project_type: string;
  description: string | null;
  status: string;
  address: string;
  post_code: string;
  is_spending_project_list: boolean;
  is_own_project: boolean;
  contact: ShareContactTypes[];
  m_purchase: ProjectSpendingDataType[];
  labour: ProjectSpendingDataType[];
  others: ProjectSpendingDataType[];
  quotation: ProjectSpendingDataType[];
  share_list: ShareContactTypes[];
  total_spending: number;
  shared_by: CommonSharedByType | null;
  can_edit?: boolean;
}

// to single object maping
export const mapSpendingType = (data: any): ProjectSpendingTypes => {
  if (!data) {
    throw new Error("Invalid Projects");
  }

  const project: ProjectSpendingTypes = {
    project_id: data.project_id,
    job_number: data.job_number,
    project_type: data.project_type,
    description: data.description,
    status: data.status,
    address: data.address,
    post_code: data.post_code,
    is_spending_project_list: data.is_spending_project_list,
    is_own_project: data.is_own_project,
    contact: mapShareContactTypes(data.contact),
    m_purchase: mapSpendingDataTypes(data.m_purchase),
    labour: mapSpendingDataTypes(data.labour),
    others: mapSpendingDataTypes(data.others),
    quotation: mapSpendingDataTypes(data.quotation),
    share_list: mapShareContactTypes(data.share_list),
    total_spending: data.total_spending,
    shared_by: data.shared_by ? mapCommonSharedByType(data.shared_by) : null,
    can_edit: data.can_edit,
  };

  return project;
};

// maping list objects
export const mapSpendingTyps = (data: any[]): ProjectSpendingTypes[] => {
  if (!Array.isArray(data)) {
    throw new Error("Invalid Projects");
  }

  return data.map(mapSpendingType);
};
